import { createFileRoute, redirect } from "@tanstack/react-router";

// Renamed to Customer Workspace. Preserve the old path as a redirect.
export const Route = createFileRoute("/_authenticated/portal/dashboard")({
  beforeLoad: () => {
    throw redirect({ to: "/portal/workspace", replace: true });
  },
});